import {Component, Injector} from '@angular/core';
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";

@Component({
    selector: 'app-companies',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class CompaniesComponent extends GeneralListComponent {


  constructor(injector: Injector) {
    super(injector);

    this.title = this.service.getTranslation("COMPANIES");

    this.columns = [
      {id: 'name',label: this.service.getTranslation("NAME"), type: ColumnType.Simple},
      {id: 'client_name',label: this.service.getTranslation("CLIENT"), type: ColumnType.Simple},
      {id: 'postalCode',label: this.service.getTranslation("POSTAL_CODE"), type: ColumnType.Simple},
      {id: 'city',label: this.service.getTranslation("CITY"), type: ColumnType.Simple},
      {id: 'address',label: this.service.getTranslation("ADDRESS"), type: ColumnType.Simple},
      {id: 'modified',label: this.service.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedBy',label: this.service.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
    ];
  }

  fetchItems() {
    this.service.getCompanies().subscribe((resp:any) => {
      this.handleFetchResponse(resp)
    })
  }

}
